import React from 'react';
import { BuildingIcon, KeyIcon, ShieldCheckIcon } from 'lucide-react';
import { AnimatedSection, AnimatedItem } from './AnimatedSection';
export function MechanismSection() {
  return <section className="w-full bg-navy-900" data-id="element-165">
      <div className="max-w-5xl mx-auto px-5 sm:px-8 py-20 md:py-28" data-id="element-166">
        <AnimatedSection data-id="element-167">
          <AnimatedItem data-id="element-168">
            <div className="flex items-center gap-3 mb-4" data-id="element-169">
              <div className="h-px flex-1 max-w-[60px] bg-gold-500/40" data-id="element-170" />
              <span className="text-gold-400 text-xs font-body font-semibold tracking-[0.2em] uppercase" data-id="element-171">
                El Mecanismo
              </span>
            </div>
          </AnimatedItem>

          <AnimatedItem data-id="element-172">
            <h2 className="font-display text-2xl sm:text-3xl md:text-4xl font-bold text-white leading-tight" data-id="element-173">
              El Sistema de{' '}
              <span className="text-gold-400" data-id="element-174">Alquiler de Activos</span>
            </h2>
          </AnimatedItem>

          <AnimatedItem data-id="element-175">
            <p className="mt-6 text-base md:text-lg text-slate-300 font-body leading-relaxed max-w-3xl" data-id="element-176">
              En lugar de comprar acciones y esperar años a que suban, este plan
              te enseña a actuar como{' '}
              <span className="text-white font-semibold" data-id="element-177">
                "la casa" en el casino financiero
              </span>
              .
            </p>
          </AnimatedItem>

          <AnimatedItem data-id="element-178">
            <p className="mt-4 text-base md:text-lg text-slate-300 font-body leading-relaxed max-w-3xl" data-id="element-179">
              Utilizamos el protocolo de{' '}
              <span className="text-gold-300 font-semibold" data-id="element-180">
                Venta de Primas
              </span>
              : cobramos una tarifa inmediata a otros inversionistas por el
              derecho de comprarnos o vendernos activos.
            </p>
          </AnimatedItem>

          {/* Analogy card */}
          <AnimatedItem data-id="element-181">
            <div className="mt-10 p-6 md:p-8 rounded-2xl bg-gradient-to-br from-navy-700 to-navy-800 border border-gold-500/15 shadow-xl" data-id="element-182">
              <div className="flex items-center gap-3 mb-4" data-id="element-183">
                <BuildingIcon className="w-6 h-6 text-gold-400" aria-hidden="true" data-id="element-184" />
                <h3 className="font-display text-lg md:text-xl font-bold text-gold-300" data-id="element-185">
                  La Analogía Perfecta
                </h3>
              </div>
              <p className="text-slate-300 font-body leading-relaxed text-base md:text-lg" data-id="element-186">
                Es exactamente igual a cobrar la renta de un departamento, pero{' '}
                <span className="text-white font-semibold" data-id="element-187">
                  sin los problemas
                </span>{' '}
                de tener inquilinos, reparaciones o hipotecas costosas. Cobras
                una "prima" (renta) por poner tus activos a disposición del
                mercado, y ese dinero entra a tu cuenta de inmediato.
              </p>
            </div>
          </AnimatedItem>

          {/* Key pillars */}
          <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-5" data-id="element-188">
            <AnimatedItem data-id="element-189">
              <div className="p-6 rounded-xl bg-navy-800/80 border border-slate-700/30 h-full" data-id="element-190">
                <div className="w-11 h-11 rounded-lg bg-gold-500/10 flex items-center justify-center mb-4" data-id="element-191">
                  <KeyIcon className="w-5 h-5 text-gold-400" aria-hidden="true" data-id="element-192" />
                </div>
                <h4 className="font-display text-lg font-bold text-white mb-2" data-id="element-193">
                  Cobro Inmediato
                </h4>
                <p className="text-slate-400 font-body text-sm leading-relaxed" data-id="element-194">
                  La prima se deposita en tu cuenta el mismo día que ejecutas la
                  operación.
                </p>
              </div>
            </AnimatedItem>

            <AnimatedItem data-id="element-195">
              <div className="p-6 rounded-xl bg-navy-800/80 border border-slate-700/30 h-full" data-id="element-196">
                <div className="w-11 h-11 rounded-lg bg-gold-500/10 flex items-center justify-center mb-4" data-id="element-197">
                  <ShieldCheckIcon className="w-5 h-5 text-gold-400" aria-hidden="true" data-id="element-198" />
                </div>
                <h4 className="font-display text-lg font-bold text-white mb-2" data-id="element-199">
                  Riesgo Controlado
                </h4>
                <p className="text-slate-400 font-body text-sm leading-relaxed" data-id="element-200">
                  Solo trabajas con empresas líderes mundiales que estarías
                  feliz de poseer.
                </p>
              </div>
            </AnimatedItem>

            <AnimatedItem data-id="element-201">
              <div className="p-6 rounded-xl bg-navy-800/80 border border-slate-700/30 h-full" data-id="element-202">
                <div className="w-11 h-11 rounded-lg bg-gold-500/10 flex items-center justify-center mb-4" data-id="element-203">
                  <BuildingIcon className="w-5 h-5 text-gold-400" aria-hidden="true" data-id="element-204" />
                </div>
                <h4 className="font-display text-lg font-bold text-white mb-2" data-id="element-205">
                  Flujo Mensual
                </h4>
                <p className="text-slate-400 font-body text-sm leading-relaxed" data-id="element-206">
                  Repites el proceso cada mes, generando un ingreso recurrente y
                  predecible.
                </p>
              </div>
            </AnimatedItem>
          </div>
        </AnimatedSection>
      </div>

      <div className="h-px bg-gradient-to-r from-transparent via-gold-500/20 to-transparent" data-id="element-207" />
    </section>;
}